import Axios from 'axios';
import { apiUrl } from '../environment';
import store from "../components/store/Store";
import { userlogout } from '../components/slice/authService';

function authRequestInterceptor(config) {
  const state = store.getState();
  const isLoggedIn = state.auth?.isLoggedIn;
  const token = localStorage.getItem("authentication");

  if (token) {
    config.headers.authorization = `${token}`;
  }

  if (isLoggedIn && !token) {
    localStorage.clear();
    store.dispatch(userlogout());
  }

  config.headers.Accept = 'application/json';
  return config;
}

export const axios = Axios.create({
  baseURL: apiUrl,
});

axios.interceptors.request.use(authRequestInterceptor);

axios.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      store.dispatch(userlogout());
    }
    return Promise.reject(error);
  }
);
